/**
 * 청구 페이지 공통 포맷팅 / 상태 판별 유틸.
 */

/**
 * 한국 원화 포맷팅. null/undefined 안전.
 */
export function formatKrw(n) {
    if (n == null || isNaN(n)) return '₩0';
    return `₩${Number(n).toLocaleString()}`;
}

/**
 * yearMonth 문자열에서 년/월 표시 추출.
 *  - "2026-04"          → { year: 2026, month: 4, isFinal: false }
 *  - "2026-04_final_..."→ { year: 2026, month: 4, isFinal: true }
 */
export function parseYearMonth(yearMonth) {
    if (!yearMonth) return { year: null, month: null, isFinal: false };
    const parts = yearMonth.split('_');
    const baseYearMonth = parts[0];
    const isFinal = parts.includes('final');
    const [year, month] = baseYearMonth.split('-').map(Number);
    return { year, month, isFinal };
}

/**
 * 청구 데이터의 상태 정보 (배지 라벨 + className) 계산.
 *
 *  - 중간정산(_final): "중간정산 MM월DD일 ~ MM월DD일"
 *  - 확정 (isFinalAmount): "확정금액"
 *  - 그 외:                  "미확정 ~MM월DD일" (어제까지)
 *
 * @returns {{ label: string, className: string }}
 */
export function getStatusInfo(yearMonth, isFinalAmount, finalizedAt) {
    const isInterimMonth = yearMonth?.includes('_final');
    if (isInterimMonth) {
        let periodText = '';
        if (finalizedAt) {
            const dateMatch = finalizedAt.match(/(\d{4}-\d{2}-\d{2})/);
            if (dateMatch) {
                const finalizedDate = new Date(dateMatch[1]);
                const endDate = new Date(finalizedDate.getTime() - 86400000);
                const year = finalizedDate.getFullYear();
                const month = finalizedDate.getMonth();
                const startDate = new Date(year, month, 1);
                const fmt = (d) => d.toLocaleDateString('ko-KR', { month: '2-digit', day: '2-digit' })
                    .replace('.', '월').replace('.', '일').replace(' ', '');
                periodText = ` ${fmt(startDate)} ~ ${fmt(endDate)}`;
            }
        }
        return { label: `중간정산${periodText}`, className: 'status-interim' };
    }
    if (isFinalAmount) {
        return { label: '확정금액', className: 'status-confirmed' };
    }
    const yesterday = new Date(Date.now() - 86400000)
        .toLocaleDateString('ko-KR', { month: '2-digit', day: '2-digit' })
        .replace('.', '월').replace('.', '일').replace(' ', '');
    return { label: `미확정 ~${yesterday}`, className: 'status-pending' };
}
